import { Button, Dialog, IconButton, Paper, Typography } from "@mui/material";
import {
  Visibility as ViewIcon,
  Check as CheckIcon,
  OpenInNew as OpenIcon,
} from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import {
  useGetNotifications,
  useSetNotificationRead,
} from "../../components/appsidebar/useNotifications";
import { Box } from "@mui/system";
import PageTitle from "../../components/PageTitle/PageTitle";
import {
  EmptyPaper,
  LoadingError,
  LoadingPaper,
  NotificationComponent,
} from "../../components/LoadingComponents";
import { useAuthUser, useIsAuthenticated } from "react-auth-kit";
import { ViewPatient } from "../../components/PatientComponents";
import { renderEUDate } from "../../utils/utils";
import {
  DailyReport,
  ViewReport,
  useGetDailyReports,
} from "../../components/ReportComponents";
import { useNavigate } from "react-router";
import columns from "./ProfileColumns";
import MaterialReactTable from "material-react-table";

function Profile(props) {
  // authentication
  const authUser = useAuthUser();
  const isAuthenticated = useIsAuthenticated();

  // notifications
  const notificationsPolling = useGetNotifications(true);
  const navigate = useNavigate();
  const readNotification = useSetNotificationRead();

  // === ViewPatient modal handling ===
  const [openViewPatient, setOpenViewPatient] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);

  const handleCloseViewPatient = () => {
    setOpenViewPatient(false);
  };

  const handleOpenPatient = (notification_id, patient_id) => {
    readNotification.mutate(notification_id);
    setSelectedPatient(patient_id);
    setOpenViewPatient(true);
  };

  const handleNewServiceClick = (notification_id) => {
    readNotification.mutate(notification_id);
    navigate("/controlroom");
  };

  const tableColumns = columns;

  return (
    <main
      style={{
        width: "100%",
      }}
    >
      <Dialog open={openViewPatient} fullScreen>
        <ViewPatient
          _editMode={false}
          patient_id={selectedPatient}
          closeModal={handleCloseViewPatient}
        />
      </Dialog>

      <PageTitle title="Mio Profilo" />
      {isAuthenticated() &&
        // authUser()?.role !== 3 &&
        (notificationsPolling.isLoading ||
        notificationsPolling.data === undefined ? (
          <LoadingPaper />
        ) : notificationsPolling.isError ? (
          <>
            <LoadingError error={notificationsPolling.error} />
          </>
        ) : (
          notificationsPolling.isSuccess && (
            <Paper
              style={{
                minHeight: "fitContent",
                margin: "3vh",
                width: "96%",
              }}
            >
              <h2 style={{ textAlign: "center", padding: 5 }}>
                Notifiche negli ultimi tre giorni
              </h2>
              {notificationsPolling.data.notifications.length === 0 ? (
                <EmptyPaper message={"Nessuna nuova notifica"} />
              ) : (
                <MaterialReactTable
                  columns={tableColumns}
                  data={notificationsPolling.data?.notifications || []}
                  initialState={{
                    density: "compact",
                    // sorting: [{id: 'isRead', desc: false}, {id: 'date', desc: false}]    // sorts by read and date
                  }}
                  enableColumnFilters={false}
                  enablePagination={true}
                  enableTopToolbar={false}
                  enableSorting={false}
                  muiTablePaperProps={{
                    elevation: 0,
                  }}
                  muiTableContainerProps={{
                    sx: {
                      overflowX: "hidden",
                    },
                  }}
                  enableColumnResizing={false}
                  enableColumnActions={false}
                  enableRowSelection={false}
                  enableRowActions={true}
                  displayColumnDefOptions={{
                    "mrt-row-actions": { header: "Azioni" },
                  }}
                  positionActionsColumn="last"
                  renderRowActions={({ row }) => (
                    <Box
                      sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}
                    >
                      <IconButton
                        key="open"
                        onClick={() => {
                          if (row.original.type === 1)
                            handleNewServiceClick(row.original.id);
                          else
                            handleOpenPatient(
                              row.original.id,
                              row.original.patient_id
                            );
                        }}
                        color="primary"
                      >
                        <OpenIcon />
                      </IconButton>

                      <IconButton
                        key="check"
                        onClick={() => {
                          readNotification.mutate(row.original.id);
                        }}
                        color="primary"
                      >
                        <CheckIcon />
                      </IconButton>
                    </Box>
                  )}
                />
              )}
            </Paper>
          )
        ))}
    </main>
  );
}

export default Profile;
